import Constants from "../../utils/CommonConstants";
import { instance } from "../../lib/api";
export const FAMILY_PACKAGES = "FAMILY_PACKAGES";
export const DISABLE_PACKAGES = "DISABLE_PACKAGES";
export const REQUIRED_PRICING_PARAMETERS_LIST = "REQUIRED_PRICING_PARAMETERS_LIST";
export const PACKAGE_CREATED = "PACKAGE_CREATED";
export const PACKAGE_UPDATED = "PACKAGE_UPDATED";
export const PACKAGE_UPDATION_FAILED = "PACKAGE_UPDATION_FAILED";
export const PACKAGE_NETSUITE_UPDATED = "PACKAGE_NETSUITE_UPDATED";
export const PACKAGE_NETSUITE_UPDATION_FAILED = "PACKAGE_NETSUITE_UPDATION_FAILED";
export const PACKAGE_DELETED = "PACKAGE_DELETED";
export const PRODUCT_MAPPINGS_ADDED = "PRODUCT_MAPPINGS_ADDED";
export const PRODUCT_MAPPINGS_DELETED = "PRODUCT_MAPPINGS_DELETED";
export const PRODUCT_MAPPINGS = "PRODUCT_MAPPINGS";
export const RESET_PACKAGE_UPDATION_STATUS = " RESET_PACKAGE_UPDATION_STATUS";
const showError = (err, dispatch) => {
  return dispatch({
    type: Constants.API_FAIL,
    errMsg: Constants.getErrorMessage(err),
  });
};
export const getPackagesForGivenFamilyIds = (familyIds, activeOnly = true) => {
  return (dispatch) => {
    if (!familyIds || !familyIds.length) return;
    Promise.all(
      familyIds.map((familyId) => {
        const url = `/sapna/v2/get-packages?package_family_id=${familyId.id}&active_only=${activeOnly}`;
        return instance({
          url,
          method: "GET",
        }).then((response) => {
          return response.data.data;
        });
      })
    )
      .then((response) => {
        dispatch({
          type: FAMILY_PACKAGES,
          payload: getFamilyPackageMap(familyIds, response),
        });
      })
      .catch(() => {
        dispatch({
          type: "API_FAIL",
        });
      });
  };
};

export const deletePackages = (data) => {
  return (dispatch) => {
    const url = `/sapna/v2/get-packages/delete`;
    return instance({
      url,
      method: "put",
      data,
    })
      .then((response) => {
        dispatch({
          type: PACKAGE_DELETED,
          payload: response.data.data ? true : false,
        });
      })
      .catch((err) => showError(err, dispatch));
  };
};
export const getPackageParameters = () => {
  return (dispatch) => {
    const url = "/sapna/v1/package-parameters";
    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        dispatch({
          type: REQUIRED_PRICING_PARAMETERS_LIST,
          payload: response.data.data,
        });
      })
      .catch((err) => showError(err, dispatch));
  };
};
export const createPackage = (data) => {
  const url = "/sapna/v2/get-packages/create";
  return (dispatch) => {
    return instance({
      url,
      method: "post",
      data,
    })
      .then((response) => {
        dispatch({
          type: PACKAGE_CREATED,
          payload: response.data.data ? true : false,
        });
        return { success: true, data: response.data.data };
      })
      .catch((err) => {
        dispatch({
          type: PACKAGE_CREATED,
          payload: false,
        });
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
        return { success: false, error: err };
      });
  };
};
export const updatePackage = (data, packageId) => {
  const url = `/sapna/v2/get-packages/update/${packageId}`;
  return (dispatch) => {
    return instance({
      url,
      method: "put",
      data,
    })
      .then((response) => {
        dispatch({
          type: PACKAGE_UPDATED,
          payload: response.data.data ? true : false,
        });
        return { success: true, data: response.data.data, packageId };
      })
      .catch((err) => {
        dispatch({
          type: PACKAGE_UPDATION_FAILED,
          errMsg: Constants.getErrorMessage(err),
        });
        return { success: false, error: err };
      });
  };
};
export const uploadPackageApprovalCsv = (packageId, csvFile) => {
  const url = `/sapna/v1/packages/${packageId}/upload-account-eligibility-csv`;
  return (dispatch) => {
    const formData = new FormData();
    formData.append("file", csvFile);

    return instance({
      url,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        dispatch({
          type: Constants.API_SUCCESS,
          errMsg: response.data.data || "CSV uploaded successfully",
        });
        return { success: true, data: response.data };
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
        return { success: false, error: err };
      });
  };
};
export const downloadPackageApprovalCsv = (packageId) => {
  const url = `/sapna/v1/packages/${packageId}/download-account-eligibility-csv`;
  return (dispatch) => {
    return instance({
      url,
      method: "get",
      responseType: "blob",
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: "text/csv" });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `account_eligibility_${packageId}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        return { success: true };
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
        return { success: false, error: err };
      });
  };
};
export const updatePackageNetsuiteStatus = (data, packageFamilyId) => {
  const url = `/sapna/v1/packages/enable-netsuite?package_family_id=${packageFamilyId}`;
  return (dispatch) => {
    return instance({
      url,
      method: "put",
      data,
    })
      .then((response) => {
        const updatedPackage = response?.data?.data || [];
        if (updatedPackage.length && updatedPackage[0].isNetsuiteEnabled)
          dispatch({
            type: PACKAGE_NETSUITE_UPDATED,
            payload: true,
          });
        else
          dispatch({
            type: PACKAGE_NETSUITE_UPDATION_FAILED,
            errMsg: "Allocation percentage is not 100 for given package id",
          });
      })
      .catch((err) => {
        dispatch({
          type: PACKAGE_NETSUITE_UPDATION_FAILED,
          errMsg: Constants.getErrorMessage(err),
        });
      });
  };
};
export const getProductMappings = (packageId) => {
  const url = `/sapna/v2/get-packages/details/${packageId}`;
  return (dispatch) => {
    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        dispatch({
          type: PRODUCT_MAPPINGS,
          payload: response.data.data.packageProductMappings,
          productPackageId: packageId,
        });
      })
      .catch((err) => showError(err, dispatch));
  };
};
export const addMappings = (packageId, data) => {
  const url = `/sapna/v2/package-products/create-mappings/${packageId}`;
  return (dispatch) => {
    return instance({
      url,
      method: "post",
      data,
    })
      .then((response) => {
        dispatch({
          type: PRODUCT_MAPPINGS_ADDED,
          status: response.data.data ? true : false,
        });
      })
      .catch((err) => showError(err, dispatch));
  };
};
export const deleteMappings = (productsIds, packageId) => {
  const url = `/sapna/v2/package-products/delete-mappings?productIds=${productsIds.toString()}&packageId=${packageId}`;
  return (dispatch) => {
    return instance({
      url,
      method: "delete",
    })
      .then(() => {
        dispatch({
          type: PRODUCT_MAPPINGS_DELETED,
          status: true,
        });
      })
      .catch((err) => showError(err, dispatch));
  };
};
const getFamilyPackageMap = (familyIds, packageList) => {
  const packageMap = {};
  familyIds.forEach((id, index) => {
    packageMap[id] = packageList[index];
  });
  return packageList.reduce(
    (list, value, index) =>
      list.concat(
        value.map((pkg) => ({
          ...pkg,
          familyId: familyIds[index].id,
          familyName: familyIds[index].name,
        }))
      ),
    []
  );
};
export const resetUpdationStatus = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_PACKAGE_UPDATION_STATUS,
    });
  };
};

export const getPackagesForFamilyId = (familyId, activeOnly = false) => {
  return async () => {
    if (!familyId) return [];
    const params = new URLSearchParams({
      package_family_id: familyId,
      active_only: activeOnly,
    });

    const url = `/sapna/v2/get-packages?${params.toString()}`;
    try {
      const response = await instance({
        url,
        method: "GET",
      });
      return response?.data?.data;
    } catch (err) {
      return [];
    }
  };
};

export const copyPackage = (data) => {
  const { copyFromPackageId, copyToPackageFamilyId, newPackageName } = data;
  const baseUrl = `/sapna/v2/package/copy`;
  const queryParams = new URLSearchParams({
    copyFromPackageId,
    copyToPackageFamilyId,
    newPackageName,
  }).toString();

  const url = `${baseUrl}?${queryParams}`;

  return (dispatch) => {
    return instance({
      url,
      method: "post",
    })
      .then((response) => {
        dispatch({
          type: PACKAGE_CREATED,
          payload: response?.data?.data ? true : false,
        });
        return response?.data?.data;
      })
      .catch((err) => {
        dispatch({
          type: PACKAGE_CREATED,
          payload: false,
        });
        showError(err, dispatch);
      });
  };
};
